import useGetMemberCompany from "#/components/company/hooks/useGetMemberCompany"

export const RTX_PARENT_COMPANY_ID = 3226

export const useIsRtxParentCompany = () => {
  const { data: company, isLoading, isError } = useGetMemberCompany()

  return {
    isRtx: company?.parentCompanyId === RTX_PARENT_COMPANY_ID,
    isLoading,
    isError
  }
}
